import { useNavigate } from 'react-router-dom'

export const REVERSE_LOGISTICS_SCAN_PRODUCT_URL = '/reverse-logistics/scan-product'

export const useReverseLogisticsScanProduct = () => {
  const navigate = useNavigate()
  return {
    go: () => {
      navigate(REVERSE_LOGISTICS_SCAN_PRODUCT_URL)
    }
  }
}
